import React, { useContext } from 'react';
import TimeTableContext from '../../context/timeTableContext'
import moment from 'moment';
var Spinner = require('react-spinkit');

const DateButtons = () => {
    const context = useContext(TimeTableContext);

    const moveCalender = (type) => {
        let dateToWork = moment(context.state.firstDayOfWeek, 'YYYYMMDD')

        if (type === "back") {
            dateToWork = dateToWork.subtract(7, 'd').format('YYYYMMDD')
            context.getTimeTableInfo(context.state.currentSchool, dateToWork)
        }
        else {
            dateToWork = dateToWork.add(7, 'd').format('YYYYMMDD')
            context.getTimeTableInfo(context.state.currentSchool, dateToWork)
        }
    }

    return (
        <div className="row">
            <div class="col-xs-12 mx-auto">
                <div className="row">
                    <div className="col-xs-4">
                        <button className="btn btn-light" onClick={() => moveCalender("back")}>שבוע הקודם</button>
                    </div>
                    <div className="col-xs-2">
                        {context.state.loading === true && <Spinner name="wave" />}
                    </div>

                    <div className="col-xs-4 text-right">
                        <button className="btn btn-light" onClick={() => moveCalender("next")}>שבוע הבא</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DateButtons;